"use client"
import React, { useState, useEffect } from "react";
import { useAppData } from "@/lib/providers/AppDataProvider";
import AmenityIcon from "@/components/categories/AmenityIcon";

import "@/components/categories/AmenityViewList.css";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

const AmenityViewList = ({ profile, condensed, mode = "BUSINESS" }) => {
  const { amenities: businessAmenities, pauAmenities } = useAppData();
  const amenities = mode === "PAU" ? pauAmenities : businessAmenities;
  const [amenitiesToDisplay, setAmenitiesToDisplay] = useState([]);

  useEffect(() => {
    if (
      profile.amenities &&
      profile.amenities.length > 0 &&
      amenities &&
      amenities.length > 0
    ) {
      var amenitiesToDisplay = profile.amenities.map(function(value, index) {
        return amenities.find(am => am.value === value);
      });
      amenitiesToDisplay = amenitiesToDisplay.filter(Boolean);
      amenitiesToDisplay.sort((a, b) => (a.order < b.order ? -1 : 1));
      setAmenitiesToDisplay(
        amenitiesToDisplay.map((amenity, index) => {
          if (condensed) {
            return (
              <OverlayTrigger
                key={amenity.value}
                placement="bottom"
                overlay={
                  <Tooltip id={`tooltip-${amenity.value}`}>
                    {amenity.label}
                  </Tooltip>
                }
              >
                <span>
                  <AmenityIcon
                    key={amenity.value}
                    amenity={amenity}
                    size="sm"
                    stacked={false}
                  />
                </span>
              </OverlayTrigger>
            );
          } else {
            return (
              <AmenityIcon
                key={amenity.value}
                amenity={amenity}
                size="sm"
                stacked={false}
              />
            );
          }
        })
      );
    }
  }, [profile, amenities]);

  if (amenitiesToDisplay.length > 0) {
    return (
      <div className={`amenity-view-list ${condensed ? "condensed" : ""}`}>
        {amenitiesToDisplay}
      </div>
    );
  } else {
    return <></>;
  }
};
export default AmenityViewList;
